import "./productCard.css";

const Rating = (props?: any) => {

    return (<div className="product-card-rating-container" data-bv-show="inline_rating" data-bv-product-id={props.sku}></div>);

}

export default Rating;